export default __webpack_public_path__ + "static/media/leetcode.23108ad6.jpg";